import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { digitalEmployees } from '../data';
import SkillSearch from '../components/SkillSearch';
import TeslaRobot from '../components/TeslaRobot';

const SearchPage: React.FC = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  
  // Extract search query from URL if present
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const skill = params.get('skill');
    if (skill) {
      setSearchQuery(skill);
    }
  }, [location]);
  
  return (
    <div className="search-page">
      <div className="search-page-header">
        <div className="search-page-title-container">
          <h1 className="search-page-title">
            AI <span className="text-gradient">Employee</span> Search
          </h1>
          <p className="search-page-subtitle">
            Find the perfect digital employee with the exact skills you need
          </p>
        </div>
        <div className="search-page-robot">
          <TeslaRobot width={100} height={100} />
        </div>
      </div>
      
      <div className="search-page-content">
        <SkillSearch employees={digitalEmployees} />
        
        <div className="search-tips">
          <h3 className="search-tips-title">Search Tips</h3>
          <ul className="search-tips-list">
            <li>
              <span className="search-tip-icon">💡</span>
              <span className="search-tip-text">
                Search for specific skills like "JavaScript", "Design", or "Marketing"
              </span>
            </li>
            <li>
              <span className="search-tip-icon">💡</span>
              <span className="search-tip-text">
                Try searching for broader categories like "Development" or "Analysis"
              </span>
            </li>
            <li>
              <span className="search-tip-icon">💡</span>
              <span className="search-tip-text">
                Click on suggested skills to quickly refine your search
              </span>
            </li>
            <li>
              <span className="search-tip-icon">💡</span>
              <span className="search-tip-text">
                Browse popular skills to discover available expertise
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
